import { useEffect, useRef } from 'react';
import { Renderer, RendererOptions } from '@hi-level/2d-renderer';

interface Floor2DViewProps {
  drawing: unknown;
}

export function Floor2DView({ drawing }: Floor2DViewProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const rendererRef = useRef<InstanceType<typeof Renderer> | null>(null);

  useEffect(() => {
    if (!containerRef.current || !drawing) return;
    const container = containerRef.current;
    let cancelled = false;
    const renderer = new Renderer();

    const options = new RendererOptions();
    options.allowDrag = true;
    options.allowSelection = false;
    options.allowTooltips = false;
    options.showCentreButton = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (options as any).element = container;

    renderer
      .init(options)
      .then(() => {
        if (cancelled) return;
        rendererRef.current = renderer;
        renderer.loadFloor(drawing);
      })
      .catch((err) => {
        console.error('Floor2DView init failed', err);
      });

    const resizeObserver = new ResizeObserver(() => {
      rendererRef.current?.resize();
    });
    resizeObserver.observe(container);

    return () => {
      cancelled = true;
      resizeObserver.disconnect();
      if (rendererRef.current === renderer) {
        rendererRef.current = null;
      }
      renderer.destroy();
    };
  }, [drawing]);

  return (
    <div
      className="w-full overflow-hidden rounded-md border border-hilevel-border bg-hilevel-offwhite h-[60vh] min-h-[360px] max-h-[800px] sm:min-h-[420px] lg:h-[640px] xl:h-[760px]"
      ref={containerRef}
    />
  );
}
